<template>
    <div class="snowsplosion-wrapper">
        <div ref="explosion" class="explosion" :style="{ 'width': size + 'px', 'height': size + 'px' }" >
            <div class="flake small" v-for="n in amountFlakes">
                <img src="/static/img/snowsplosion/flake.png" />
            </div>
            <div class="flake top">
                <img src="/static/img/snowsplosion/flake.png" />
            </div>
            <div class="flake glow">

            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .snowsplosion-wrapper {
        position:absolute;
        top:0;
        left:0;
    }

    .explosion{
        position:absolute;
        top:0;
        left:0;
        transform:translateX(-50%) translateY(-50%);
        overflow: hidden;

        .flake{
            position:absolute;
            top:30%;
            left:30%;
            width: 40%;
            height: 40%;
        }

        .glow{
            // background: radial-gradient( closest-side, rgba( white, 1 ) 40%, rgba( white, 0.5 ) 70%, rgba( white, 0 ) 100% );
            background-image:radial-gradient(closest-side, white, white 57%, transparent);
        }
    }
</style>

<script>
    /* eslint-disable */
    import { TweenMax, TimelineMax } from 'gsap';
    import CustomEase from '@/vendor/gsap/CustomEase';
    import browserCheck from '@/app/mixins/browserCheck';

    const MIN_AMOUNT = 15;
    const MAX_AMOUNT = 105;

    export default {
        mixins: [ browserCheck ],

        props: {
            size: {
                type: Number,
                default: 600
            },
            autoAnimate: {
                type: Boolean,
                default: false
            },
            autoFadeOut: {
                type: Boolean,
                default: false
            },
            complexity: {
                type: Number,
                default: 1
            },
        },

        computed: {
            cappedComplexity: function ()
            {
                return Math.min( 1, Math.max( 0, this.complexity ));
            },
            amountFlakes: function ()
            {
                return Math.floor( this.cappedComplexity * ( MAX_AMOUNT - MIN_AMOUNT ) + MIN_AMOUNT );
            }
        },

        mounted()
        {
            // this.createAnim();
            if( this.autoAnimate )
            {
                this.startAnim();
            }
        },

        methods: {
            createAnim()
            {
                if( this.animation )
                {
                    this.animation.invalidate().kill();
                }

                let rootElem = this.$refs[ 'explosion' ];
                let smallFlakes = [].slice.call( rootElem.querySelectorAll( '.flake.small' ) );
                let START_TIME = 0.5;
                let FADEOUT_TIME = 4.5;

                this.animation = new TimelineMax({ paused: true });

                this.animation.from( rootElem.querySelector( '.flake.top' ), 0.1, { autoAlpha: 0 }, START_TIME );
                this.animation.from( rootElem.querySelector( '.flake.top' ), 1.5, { scale: 0, ease: Expo.easeIn }, START_TIME );
                this.animation.from( rootElem.querySelector( '.flake.top' ), 1, { rotation: 360, ease: Sine.easeInOut }, START_TIME + 0.5 );

                this.animation.from( rootElem.querySelector( '.flake.glow' ), 1.5, { scale: 0, ease: Expo.easeIn }, START_TIME );

                const MAX_RADIUS = this.size/2;
                const MIN_RADIUS = this.size/4;
                const MIN_TIME = 5;
                const MAX_TIME = 7;
                const INSERT_TIME = START_TIME + 1.4;

                for( let flake of smallFlakes )
                {
                    let thisRadius = MIN_RADIUS + Math.random() * ( MAX_RADIUS - MIN_RADIUS );
                    let angle = Math.random() * 360;
                    let time = MIN_TIME + Math.random() * ( MAX_TIME - MIN_TIME );
                    let travelX = thisRadius * Math.cos( angle );
                    let travelY = thisRadius * Math.sin( angle );
                    TweenMax.set( flake, { scale: 0.1 + 0.05 * Math.random() });

                    this.animation.to( flake, time, { x: travelX, y: travelY, ease:Expo.easeOut }, INSERT_TIME );
                    this.animation.from( flake, 0.1, { autoAlpha: 0 }, INSERT_TIME );
                    this.animation.to( flake, time - 0.9, { autoAlpha: 0 }, INSERT_TIME + 0.1 );
                }

                if( this.autoFadeOut )
                {
                    this.animation.to( rootElem.querySelectorAll( '.flake.glow, .flake.top' ), 1, { rotation: 360, scale: 2, ease: Back.easeIn }, FADEOUT_TIME );
                    this.animation.to( rootElem.querySelectorAll( '.flake.glow, .flake.top' ), 0.5, { autoAlpha: 0, ease: Sine.easeIn }, FADEOUT_TIME + 0.5 )
                }
            },

            getAnimation()
            {
                if( !this.animation || this.animation.totalDuration() === 0 )
                {
                    this.createAnim();
                }

                return this.animation;
            },

            startAnim( recreate = false )
            {
                if( recreate || !this.animation )
                {
                    this.createAnim();
                }
                this.animation.restart();
            },

            stopAnim()
            {
                if( this.autoFadeOut )
                {
                    this.animation.progress( 1 );
                }
                else
                {
                    this.animation.progress( 0 ).pause();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Snowsplosion.vue